import { Send, Instagram } from "lucide-react";

// --- LINK UFFICIALI ---
const TELEGRAM_LINK = "https://t.me/zerosignals_hub";
const INSTAGRAM_LINK =
  "https://www.instagram.com/zerosignals_hub?igsi=eHV6ZTE1OXU0ZDE3";
// ----------------------

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/5 py-12"
    >
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-6 px-6 sm:flex-row sm:items-center lg:px-10">

        {/* LOGO + NOME + COPYRIGHT */}
        <div className="flex items-center gap-0">

          {/* ICONA LOGO */}
          <div className="flex items-center">
            <img
              src="https://customer-assets-0z36b82j.emergentagent.net/job_zero-signals-landing/artifacts/jmp0fm2e_Logo%20FAMI%20-%20Logo%20ZS%20-%20Zeta%20%285%29.png"
              alt="Zero Signals Logo"
              className="h-12 w-auto object-contain"
            />
          </div>

          {/* ZEROSIGNALS + COPYRIGHT */}
          <div className="-translate-x-2">
            <div className="font-display text-sm font-bold">
              <img
                src="https://customer-assets-0z36b82j.emergentagent.net/job_zero-signals-landing/artifacts/03gyhn3g_Logo%20FAMI%20-%20Logo%20ZS%20-%20Zeta%20%288%29.png"
                alt="ZeroSignals"
                className="h-5 w-auto origin-left scale-[5.5] object-contain"
              />
            </div>

            <div className="text-[11px] text-white/40">
              © {new Date().getFullYear()} — Powered by Progetto FAMI
            </div>
          </div>
        </div>

        {/* LINK FOOTER */}
        <div className="flex flex-wrap items-center gap-6 text-xs uppercase tracking-[0.22em] text-white/45">
          <a
            href="#chisiamo"
            className="hover:text-white"
            data-testid="footer-link-who"
          >
            CHI
          </a>

          <a
            href="#ilprogetto"
            className="hover:text-white"
            data-testid="footer-link-what"
          >
            COSA
          </a>

          <a
            href="#the-hub"
            className="hover:text-white"
            data-testid="footer-link-hub"
          >
            Hub
          </a>
        </div>

        {/* SOCIAL */}
        <div className="flex flex-wrap items-center gap-3">

          {/* TELEGRAM */}
          <a
            href={TELEGRAM_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-telegram-cta"
            className="inline-flex items-center gap-2 rounded-full border border-brand-neon-blue/40 bg-brand-neon-blue/5 px-4 py-2 text-xs font-semibold uppercase tracking-[0.18em] text-brand-neon-blue transition-all hover:bg-brand-neon-blue hover:text-black"
          >
            <Send size={13} />
            Telegram
          </a>

          {/* INSTAGRAM */}
          <a
            href={INSTAGRAM_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-cta"
            className="inline-flex items-center gap-2 rounded-full border border-pink-500/40 bg-pink-500/5 px-4 py-2 text-xs font-semibold uppercase tracking-[0.18em] text-pink-400 transition-all hover:bg-pink-500 hover:text-black"
          >
            <Instagram size={13} />
            Instagram
          </a>
        </div>
      </div>
    </footer>
  );
}